import { Routes, Route } from "react-router-dom";


import Login from "../components/pages/user/Login/Login";
import Register from "../components/pages/user/Register/Register";
import ResetPassword from "../components/pages/user/ResetPassword/ResetPassword";
import ResetPasswordForm from "../components/pages/user/ResetPassword/PasswordResetForm";
import VerifyEmailPage from "../components/pages/user/Register/VerifyEmail";

import OrganisationOnboarding from '../components/pages/Organisation/OrganisationOnboarding'
import Dashboard from "../components/pages/Organisation/Dashboard/Dashboard";
import Members from '../components/pages/Organisation/Dashboard/Members';
import Campaigns from '../components/pages/Organisation/Dashboard/Campaigns';
import Transactions from '../components/pages/Organisation/Dashboard/Transactions';
import Account from '../components/pages/Organisation/Dashboard/AccountManagement';
import HelpCenter from '../components/pages/Organisation/Dashboard/HelpCenter';
import Onboarding from '../components/pages/Organisation/OrganisationOnboarding';
import EmailVerify from '../components/pages/Organisation/VerifyEmail';
import UserProtectedRoute from "../components/pages/user/ProtectRoutes";
import SetPassword from "../components/pages/Organisation/SetPasswod";
import SendEmail from "../components/pages/Organisation/Dashboard/SendEmails";
import Memberships from "../components/pages/Organisation/Dashboard/Memberships";












function OrganisationRoutes() {
  return (
    <Routes>

    

    {/* Show the welcome notice only in protected routes
      <Route 
        path="/dashboard" 
        element={
          <UserProtectedRoute>
            <UserWelcomeNotice />  
            
            
            
            <Dashboard />
          </UserProtectedRoute>
        }
      />

      */}


       {/* Protected Routes */}
            <Route 
              path="/dashboard" 
              element={
                <UserProtectedRoute>
                  <Dashboard />
                </UserProtectedRoute>
              }
            />

            <Route 
              path="/members" 
              element={
                <UserProtectedRoute>
                  <Members />
                </UserProtectedRoute>
              }
            />

            <Route 
              path="/campaigns" 
              element={
                <UserProtectedRoute>
                  <Campaigns />
                </UserProtectedRoute>
              }
            />

            <Route 
              path="/transactions" 
              element={
                <UserProtectedRoute>
                  <Transactions />
                </UserProtectedRoute>
              }
            />


            <Route 
              path="/email" 
              element={
                <UserProtectedRoute>
                  <SendEmail />
                </UserProtectedRoute>
              }
            />

            <Route 
              path="/account" 
              element={
                <UserProtectedRoute>
                  <Account />
                </UserProtectedRoute>
              }
            />


            <Route
              path="/help"
              element={
                <UserProtectedRoute>
                  <HelpCenter />
                </UserProtectedRoute>
              }
            />

            <Route
              path="/memberships"
              element={
                <UserProtectedRoute>
                  <Memberships />
                </UserProtectedRoute>
              }
            />


  
      <Route path="/register" element={<Onboarding />} />
      <Route path="/verify" element={<EmailVerify />} />
      <Route path="/set-password" element={<SetPassword />} />








     



  



      {/* Organisation Onboarding Route */}
      <Route path="/organisation-onboarding" element={<OrganisationOnboarding />} />

    </Routes>
  );
}




export default OrganisationRoutes;
